import React from 'react'
import { useInvoiceListContext } from '../Context'
import { useFinalize } from './useFinalize'
import { BusyButton } from '@ztechapps/webui.button'

export const FinalizeButton = () => {
  const context = useInvoiceListContext()
  const [onFinalize, { loading, hasPermission }] = useFinalize()
  const hasSelected = context.listWithSelection.hasSelected

  const onClick = async () => {
    const invoiceIds = context.listWithSelection.selectedList.map((item) => item._id)
    await onFinalize(invoiceIds)
  }

  const disabled = !hasPermission || !hasSelected
  const buttonTitle = disabled
    ? 'You need to have canSend and canEdit permission and select at least one invoice.'
    : 'This will send the invoice to the customer and copy over to quickbooks.'

  return (
    <BusyButton
      bsStyle="primary"
      icon="flag-checkered"
      isBusy={loading}
      busyText="Finalizing..."
      text="Finalize"
      title={buttonTitle}
      onClick={onClick}
      disabled={disabled}
    />
  )
}
